export default __webpack_public_path__ + "static/media/Mobile_Hero_02.9ac3f48b.jpeg";